<template>
  <div>
    <form @submit.prevent="handleSubmit">
      <LocalCampos ref="local" />
      <br />
      <Endereco ref="endereco" />
      <br />
      <div style="text-align: right">
        <md-button :to="{ name: 'LocalIndex' }" class="md-accent">
          Voltar
        </md-button>
        <md-button type="submit" class="md-raised md-primary">
          Salvar
        </md-button>
      </div>
      <br />
    </form>
    <md-progress-bar v-if="enviando" md-mode="indeterminate" />
  </div>
</template>

<script>
import Endereco from '../../components/Endereco'
import LocalCampos from '../../components/local/LocalCampos'
import http from '../../utils/http'

export default {
  name: 'LocalNovo',
  components: { LocalCampos, Endereco },
  data() {
    return {
      local: {},
      enviando: false,
    }
  },
  methods: {
    async handleSubmit() {
      const endereco = this.$refs.endereco.returnData()
      const local = this.$refs.local.returnData()

      const validacao = endereco.validation && local.validation

      if (!validacao) {
        return
      }
      this.enviando = true

      const response = http.post('local', {
        ...local.data,
        endereco: {
          ...endereco.data,
        },
      })

      if (response) {
        const back =
          (this.$router.params && this.$router.params.routeBack) || 'LocalIndex'
        await this.$router.push({ name: back || 'LocalIndex' })
      }

      this.enviando = false
    },
  },
}
</script>

<style lang="scss" scoped>
.left-zero {
  padding-left: 0;
  margin-left: 0;
  margin-right: 5% !important;
}
</style>
